import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FetchDataService } from '../fetch-data.service';

@Component({
  selector: 'app-showweather',
  templateUrl: './showweather.component.html',
  styleUrls: ['./showweather.component.css']
})
export class ShowweatherComponent implements OnInit {

  constructor(private route: ActivatedRoute, private weatherData: FetchDataService) { }

  city: string;
  dataComing:any;
  tempInF = {
    'temp': 0,
    'feels_like': 0,
    'temp_min': 0,
    'temp_max': 0
  }
  timeInRead = {
    'timezone' : 0,
    'sunrise' : 0,
    'sunset' : 0
  }



  ngOnInit(): void {
    this.getCityFromParams();
  }

  getCityFromParams() {
    this.route.params.subscribe(param => { this.city = param.city; console.log(param) });
    this.getDataFromApi(this.city);
  }

  async getDataFromApi(data) {
    console.log('weather data function called')
    this.dataComing = await this.weatherData.getweatherData(data);
    console.log(this.dataComing);
    this.dataConversionToFarhenite(this.dataComing['main']);
    let timeObj = {
      'timezone' : this.dataComing['dt'],
      'sunrise' : this.dataComing['sys']['sunrise'],
      'sunset' : this.dataComing['sys']['sunset']
    }
    this.dataConversionToRedableFormat(timeObj);
  }

  dataConversionToFarhenite(data:Object) {
    for(const datas in data){
        console.log(datas);
        let tempInFarhenite = data[datas]-273;
       this.tempInF[datas]= Math.round(tempInFarhenite);
    }
    console.log(this.tempInF);
  }

  dataConversionToRedableFormat(data:Object){
    for(const datas in data){
      console.log(datas);
      var date = new Date(data[datas] * 1000);
      var hours = date.getHours();
      var minutes = "0" + date.getMinutes();
      var seconds = "0" + date.getSeconds();
      var formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
      this.timeInRead[datas] = formattedTime;
    }
  }
}